import React from 'react'
import { useTranslations } from 'next-intl'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { TableInputProps } from '@/lib/table/types'

export function TableInput({ value, onChange, format, onFormatChange }: TableInputProps) {
  const t = useTranslations('MarkdownTable')

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-bold">{t('inputTitle')}</h2>
        <Select value={format} onValueChange={onFormatChange}>
          <SelectTrigger className="w-40">
            <SelectValue placeholder={t('selectInputFormat')} />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="markdown">Markdown</SelectItem>
            <SelectItem value="csv">CSV</SelectItem>
            <SelectItem value="json">JSON</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <textarea
        className="w-full h-80 p-4 font-mono text-sm app-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        spellCheck={false}
      />
    </div>
  )
} 